<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getBusinessAttrList_data.attrName"
          placeholder="请输入业务属性名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getBusinessAttrList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addBusinessAttr"
          @click=" $form('addBusinessAttr')"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加业务属性
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getBusinessAttrList'
      api='getBusinessAttrList'
      updateapi='updateBusinessAttr'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addBusinessAttr:    [ "新增业务属性信息", "el-icon-circle-plus" ],
        updateBusinessAttr: [ "修改业务属性信息", "el-icon-edit-outline"],
        $succeed$: getBusinessAttrList
      }'
      @close='$form("addBusinessAttr","reset")' >
      <hide slot='attrId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attrId: null,

      tableColums_getBusinessAttrList: {
        $selection: false,

        attrName: '业务属性名称',

        attrRemark: '描述',

        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateBusinessAttr && `@text: 编辑#success
           @click: $form("updateBusinessAttr",$row)
          `,
          this.deleteBusinessAttr && `@text: 删除#danger
           @click: _confirm('确定要删除该业务属性吗?')
                   .trigger('deleteBusinessAttr',{attrId:$row.attrId})
                   .trigger('getBusinessAttrList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getBusinessAttrList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/BussinessAttr.vue